import React from 'react';
export function BonusSection() {
  const bonuses = [{
    title: 'Planificación Anual',
    value: '$9.990',
    desc: 'Todo el año organizado'
  }, {
    title: 'Banco de Rutinas',
    value: '$7.990',
    desc: 'Circuitos listos por nivel'
  }, {
    title: 'Clases Dinámicas',
    value: '$9.990',
    desc: 'Actividades para enganchar alumnos'
  }, {
    title: 'Sistema de Evaluación',
    value: '$7.990',
    desc: 'Seguimiento real del progreso'
  }];
  return <section className="bg-[#F5F5F5] py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <h2 className="text-xl md:text-2xl font-black text-[#0B1F3A] text-center mb-3 uppercase tracking-tight" data-id="element-16">
          🎁 BONUS DE REGALO
        </h2>

        <div className="grid grid-cols-2 gap-1.5 mb-3" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-gray-200 rounded-lg p-2.5 relative overflow-hidden flex flex-col shadow-sm" data-id="element-18">
              <div className="absolute top-0 right-0 bg-[#FF6B00] text-white text-[9px] font-black px-2 py-0.5 rounded-bl-lg z-10" data-id="element-19">
                #{i + 1}
              </div>
              <h3 className="text-xs md:text-sm font-black text-[#0B1F3A] mb-0.5 flex items-start gap-1 mt-1 leading-tight" data-id="element-20">
                <span className="text-[#FF6B00]" data-id="element-21">🎁</span>
                <span data-id="element-22">{bonus.title}</span>
              </h3>
              <p className="text-gray-500 text-[10px] md:text-xs mb-1.5 ml-5" data-id="element-23">
                👉 {bonus.desc}
              </p>
              <div className="border-t border-gray-100 pt-1 flex justify-between items-center mt-auto" data-id="element-24">
                <span className="text-gray-400 line-through text-[10px]" data-id="element-25">
                  {bonus.value}
                </span>
                <span className="text-green-600 font-black text-xs" data-id="element-26">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="max-w-xs mx-auto bg-white border-3 border-[#FF6B00] rounded-xl p-3 text-center shadow-lg" data-id="element-27">
          <p className="text-gray-500 font-bold text-[10px] mb-0.5 uppercase tracking-wide" data-id="element-28">
            Valor total:
          </p>
          <p className="text-lg font-black text-gray-400 line-through mb-0.5" data-id="element-29">
            $35.960
          </p>
          <p className="text-2xl md:text-3xl font-black text-[#FF6B00]" data-id="element-30">
            🔥 HOY: GRATIS
          </p>
        </div>
      </div>
    </section>;
}